import { useEffect, useState } from "react";
import { SectionProps } from "../../../shared/types";
import { useIntersecting } from "../../../../../hooks/useIntersecting";
import styled from "styled-components";
import BaseSection from "../../../BaseSection";
import { animations, color, cssTemplate, media } from "../../../../../constants/styles";
import { maxWidth } from "../../../shared/styled";
import { ReactComponent as LogoBar } from "../../../../../svgs/logo-bar.svg";

interface Props extends SectionProps {
  height: string;
}
const ScrollOverlayHero: React.FC<Props> = ({ screenType, height }) => {
  const { ref, isIntersecting } = useIntersecting();
  const [interacted, setInteracted] = useState<boolean>(false);

  useEffect(() => {
    if (isIntersecting) setInteracted(true);
  }, [isIntersecting]);

  return (
    <Base>
      <SectionLayout
        ref={ref} theme={{ isIntersecting: interacted }}
        className="homeSection1Container"
        height={height}
      >
        {screenType === 'PC' && (
          <TitleWrapper>
            <Title>
              <span>WHAT’S UP?</span>
              <Text2>
                <span>WE’RE</span>
                <Logo
                  style={{
                    position: "relative",
                  }}
                >
                  <LogoBar />
                  <LogoBar />
                </Logo>
                <span>LOGUP!</span>
              </Text2>
            </Title>
            <Paragraph>
              We create digital solutions that thunder-surprise the world
            </Paragraph>
          </TitleWrapper>

        )}

        {screenType === "TABLET" && (
          <TitleWrapper
          >
            <Title>
              <span>
                WHAT’S <br />
                UP?
              </span>
              <Text2>
                <span>WE’RE</span>
                <div>
                  <Logo
                    style={{
                      position: "relative",
                    }}
                  >
                    <LogoBar />
                    <LogoBar />
                  </Logo>
                  <span>LOGUP!</span>
                </div>
              </Text2>
            </Title>
            <Paragraph>
              We create digital solutions that thunder-surprise the world
            </Paragraph>
          </TitleWrapper>
        )}

        {screenType === "MOBILE" && (
          <TitleWrapper
          >
            <Title>
              <span>
                WHAT’S
                <br />
                UP?
              </span>
              <Text2>
                <span>
                  WE’RE
                </span>
                <div>
                  <Logo
                    style={{
                      position: "relative",
                    }}
                  >
                    <LogoBar />
                    <LogoBar />
                  </Logo>
                  <span>LOGUP!</span>
                </div>
              </Text2>
            </Title>
            <Paragraph>
              We create digital solutions that thunder-surprise the world
            </Paragraph>
          </TitleWrapper>
        )}
      </SectionLayout>
    </Base>

  )
};

export default ScrollOverlayHero;

const Base = styled(BaseSection)`
  position: relative;
  min-height: 600px;
  background: #111;
`;
const SectionLayout = styled.div<{ height: string }>`
  background: #111;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: ${({ height }) => height};
  position: relative;
  width: 100%;
  left: 0;
  top: 0;
  overflow: hidden;
  ${(props) => cssTemplate.fadeInOut(props)}
  ${media.TABLET} {
    padding: 0px 48px;
  }

  ${media.MOBILE} {
    padding: 0px 24px;
  }
  isolation: isolate;
`;
const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  background-size: cover;
  opacity: 1;
  min-height: 600px;
  max-width: 100vw;
  max-height: 100vh;
  font-family: "Fivo Sans Modern";
  padding: 0px 48px;
  ${maxWidth};
  overflow: hidden;
  ${media.TABLET} {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px 48px;
    opacity: 1;
    min-height: 600px;
    justify-content: center;
    background-size: cover;
  }
  ${media.MOBILE} {
    padding: 0px 24px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    opacity: 1;
    min-height: 600px;
    height: calc(var(--vh, 1vh) * 100);
    justify-content: center;
    background-size: cover;
  }
`;
const Text2 = styled.div`
  display: flex;
  flex-wrap: nowrap;
  position: relative;
  ${media.TABLET} {
    flex-wrap: wrap;
  }
  ${media.MOBILE} {
    flex-wrap: wrap;
  }
`;
const Title = styled.h2`
  color: #ffffff;
  font-size: 150px;
  line-height: 192px;
  font-weight: 900;

  letter-spacing: 0.9;
  white-space: nowrap;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  @media (max-width: 1289px) {
    font-size: 120px;
    line-height: 144px;
  }

  ${media.TABLET} {
    font-family: "Fivo Sans Modern";
    font-style: normal;
    font-weight: 900;
    font-size: 120px;
    line-height: 144px;
    /* identical to box height, or 120% */
    display: flex;

    flex-wrap: wrap;
    /* Gray/Gray-08 (White) */

    color: #ffffff;
  }

  ${media.MOBILE} {
    font-family: "Fivo Sans Modern";
    font-style: normal;
    font-weight: 900;
    font-size: 60px;
    line-height: 72px;
    /* identical to box height, or 120% */

    display: flex;
    align-items: flex-start;

    /* Gray/Gray-08 (White) */

    color: #ffffff;
    padding: 0 24px;
  }
`;
const Logo = styled.div`
  display: inline-block;
  position: relative;
  min-width: 90.51px;
  height: 108px;
  z-index: 200;
  margin-top: 32px;
  margin-left: 32px;

  > svg {
    position: absolute;
    width: 81.27px;
    height: 65.01px;
    &:nth-child(1) {
      top: 0;
      left: 0;
      animation: ${animations.firstArrow} 0.8s ease-in-out;
    }

    &:nth-child(2) {
      bottom: 0;
      right: 0;
      animation: ${animations.secondArrow} 0.8s ease-in-out;
    }
  }

  @media (max-width: 1289px) {
    margin-top: 20px;
    margin-left: 16px;

    & > svg {
      position: absolute;
      width: 71.27px;
      height: 55.01px;
      &:nth-child(1) {
        top: 0;
        left: 0;
        animation: ${animations.firstArrow} 0.8s ease-in-out;
      }

      &:nth-child(2) {
        bottom: 20px;
        right: 8px;
        animation: ${animations.secondArrow} 0.8s ease-in-out;
      }
    }
  }

  ${media.TABLET} {
    margin-top: 0px;
    margin-left: 0px;
    min-width: 71px;
    height: 84px;
    position: relative;
    > svg {
      position: absolute;

      width: 64px;
      height: 51px;
      &:nth-child(1) {
        top: 0;
        left: 0;
      }

      &:nth-child(2) {
        bottom: 0;
        right: 0;
      }
    }
  }
  ${media.MOBILE} {
    margin-top: 0px;
    margin-left: 0px;
    min-width: 35px;
    height: 42px;
    position: relative;
    > svg {
      position: absolute;
      width: 31.41px;
      height: 25.38px;
      &:nth-child(1) {
        top: 0;
        left: 0;
      }

      &:nth-child(2) {
        bottom: 0;
        right: 0;
      }
    }
  }
`;
const Paragraph = styled.p`
  font-weight: 700;
  font-size: 28px;
  line-height: 34px;
  color: ${color.GREEN};
  text-align: left;
  max-width: 1200px;
  width: 100%;
  ${media.TABLET} {
    font-family: "Fivo Sans Modern";
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
  }
  ${media.MOBILE} {
    font-family: "Fivo Sans Modern";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    /* or 122% */

    /* Primary/Neon Yellow Green 05 ⭐️ */

    color: #b3ff01;
    padding: 0 24px;
  }
`;